import React, { Component, Fragment } from 'react';
import Clear from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import StrModal from '../../shared/StrModal';
import Cropper from './Cropper';
import ThumbnailPreview from './ThumbnailPreview';
import ImageSpecs from './ImageSpecs';

import './ThumbnailField.scss';

class ThumbnailField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
  }

  showModal(editExisting) {
    this.setState({ modalOpen: true, editExisting: editExisting });
  }

  hideModal() {
    this.setState({ modalOpen: false });
  }

  handleCrop(url) {
    this.hideModal();
    this.props.onChange(url);
  }

  render() {
    return (
      <div
        className="thumbnail-upload_container"
        data-testid="thumbnail-upload"
      >
        {this.props.removeable && (
          <Clear
            className="thumbnail-upload_remove-preview"
            data-testid="remove-thumbnail-upload"
            onClick={this.props.onRemove}
            style={{ fontSize: '18px', color: '#cdcdcd' }}
          />
        )}
        {this.props.thumbnailUrl ? (
          <ThumbnailPreview
            thumbnailUrl={this.props.thumbnailUrl}
            onImageClick={() => this.showModal(true)}
            onChangeImageClick={() => this.showModal(false)}
          />
        ) : (
          <Fragment>
            <div
              role="button"
              className={`add-thumbnail-button ${this.props.hasError &&
                'has-error'}`}
              tabIndex={0}
              onClick={this.showModal}
              onKeyDown={this.showModal}
            >
              <div className="add-thumbnail-button-plus">+</div>
              <div className="add-thumbnail-button-text">Add Image</div>
            </div>
            {this.props.showImageSpecs && (
              <ImageSpecs action={this.props.action} />
            )}
          </Fragment>
        )}
        <StrModal
          open={this.state.modalOpen}
          hideModal={this.hideModal}
          title="Add Thumbnail"
        >
          {this.state.editExisting ? (
            <Cropper
              onCrop={this.handleCrop}
              imageSrc={this.props.thumbnailUrl}
              action={this.props.action}
            />
          ) : (
            <Cropper onCrop={this.handleCrop} action={this.props.action} />
          )}
        </StrModal>
      </div>
    );
  }
}

ThumbnailField.propTypes = {
  action: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  hasError: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showImageSpecs: PropTypes.bool,
  removeable: PropTypes.bool,
  onRemove: PropTypes.func
};

ThumbnailField.defaultProps = {
  action: 'clickout',
  thumbnailUrl: '',
  hasError: false,
  showImageSpecs: true,
  removeable: false,
  onRemove: () => {}
};

export default ThumbnailField;
